import { ExtendedDistrict } from '@bpd-library/utilities';

import { FormattedStatus, StatusTranslations } from '.';

/**
 * @description Returns the translated district status as Text element and color
 * @param {ExtendedProjectPhase} projectPhase
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatDistrictStatus = (district: ExtendedDistrict): FormattedStatus | undefined => {
    const { status } = district;

    if (!status || status === 'NotActive') return;

    return StatusTranslations.FORMATTED[status];
};

export { formatDistrictStatus };
